import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { List } from 'immutable';

import { Paragraph, View, CoreLink } from '@uncinc/react-drupal-core';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';
import { Steps } from '@uncinc/uncinc-react-kitchen-sink';

import StaffTeaser from '../../Staff/Teaser';

import {
  Breadcrumbs,
  Container,
  TitleHeaderBlock,
  WysiwygField,
} from '../../../../components';

import './style.scss';

const DossierFull = ({ entity, dateLabel }) => {
  const dispatch = useDispatch();
  const { t } = i18next;

  const nid = entity.getIn(['nid', 0, 'value']);
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed']);
  const currentStatus = entity.getIn(['field_dossier_status', 0, 'entity', 'name', 0, 'value']);
  const experts = entity.get('field_experts', List());

  const [steps, setSteps] = useState([]);
  const dossierStatuses = useSelector((state) => state.getIn(['view', 'vocabulary_terms', 'dossier_statuses', 'entities']));

  useEffect(() => {
    dispatch(viewGet('vocabulary_terms', 'dossier_statuses', 0, null, {}));
  }, [dispatch]);

  useEffect(() => {
    if (dossierStatuses) {
      setSteps(dossierStatuses.toJS().map((status) => ({ label: status.name })));
    }
  }, [dossierStatuses, setSteps]);

  return (
    <div className="NodeDossier">
      <Container small>
        <Breadcrumbs includeCurrent />
        <div className="NodeDossier__infoheading">
          <div className="wrapper">
            <span className="name">
              {t('node.dossier.title').toUpperCase()}
            </span>
            <i className="icon icon-asterisk icon-variant-1" />
            {steps.length && (
              <span className="status">
                {
                  currentStatus === steps[steps.length - 1].label
                    ? t('node.dossier.in_effect')
                    : t('node.dossier.in_progress')
                }
              </span>
            )}
            <i className="icon icon-asterisk icon-variant-1" />
          </div>
          <span className="effect_date">
            {dateLabel}
          </span>
        </div>
        <h1 className="NodeDossier__title">
          {title}
        </h1>
        <WysiwygField
          html={body}
          className="NodeDossier__body"
        />
        <div className="NodeDossier__timeline">
          <div className="timeline__header">
            <h3 className="timeline__title">{t('status')}</h3>
            <CoreLink className="timeline__icon" to="/nl/hoe-komt-een-wet-tot-stand">
              <i className="icon icon-info icon-variant-1" />
            </CoreLink>
          </div>
          <Steps steps={steps} currentStep={steps.findIndex((step) => step.label === currentStatus)} />
        </div>
      </Container>

      {entity.get('field_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs').map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      )}

      <Container small>
        <h2 className="title">{experts.size > 1 ? t('node.dossier.experts') : t('node.dossier.expert')}</h2>
        <div className="NodeDossier__experts">
          {experts.map((expert) => (
            <div className="wrapper">
              <StaffTeaser entity={expert.get('entity')} />
            </div>
          ))}
        </div>
      </Container>

      {entity.get('field_secondary_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_secondary_paragraphs').map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      )}

      <TitleHeaderBlock
        title={i18next.t('related_content')}
      >
        <View
          id="latest_content"
          display="by_dossier"
          args={[nid]}
        />
      </TitleHeaderBlock>
    </div>
  );
};

export default DossierFull;
